import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import BugReportIcon from '@mui/icons-material/BugReport';
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from '@mui/icons-material/Dashboard';

import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import NavBar from "./NavBar";
import { useMsal } from "@azure/msal-react";
import { getLoggedUser, getRefreshToken, loggedOut } from "../../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// const adminMenus = [
//   {
//     name: "Dashboard",
//     path: "/",
//     icon: <DashboardIcon />,
//   },
//   {
//     name: "Users",
//     path: "/users",
//     icon: <PersonIcon />,
//   },
//   {
//     name: "Customers",
//     path: "/clients",
//     icon: <BusinessIcon />,
//   },
//   {
//     name: "Issues",
//     path: "/issues",
//     icon: <BugReportIcon />,
//   },
// ];
const adminMenus = [
  {
    name: "Dashboard",
    path: "/",
    icon: <DashboardIcon />,
  },
  {
    name: "Manage",
    icon: <SettingsIcon />,
    subItems: [
      {
        name: "Users",
        path: "/users",
        icon: <PersonIcon />,
      },
      {
        name: "Customers",
        path: "/clients",
        icon: <BusinessIcon />,
      },
      {
        name: "Issues",
        path: "/issues",
        icon: <BugReportIcon />,
      },
    ],
  },
];


export default function MiniDrawer(props) {
  const { open, setOpen } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const { instance, accounts } = useMsal();
  const currentUser = useSelector(getLoggedUser);
  const [leftMenus, setLeftMenus] = useState(adminMenus);

  const dispatch = useDispatch()

  const handleListItemClick = (event, index) => {
    event.preventDefault();
    setSelectedIndex(index);
    navigate(index, { replace: true });
  };

  // const handleLogout = (e) => {
  //   instance.logoutPopup({
  //     postLogoutRedirectUri: "/",
  //     mainWindowRedirectUri: "/",
  //   });
  // };

  const handleLogout = () => {
    dispatch(loggedOut())
    navigate('/login');
  };



  const handleDrawerOpen = () => {
    setOpen(prev => !prev);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <NavBar open={open} handleDrawerOpen={handleDrawerOpen} />
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>


          <Typography variant="body2">
            <img src="/Images/wflogoblack.png" style={{ width: "95%", marginTop: "10px", marginLeft: "10px" }} />
            <Typography variant="subtitle1" sx={{ mt: -1, fontSize: 13, ml: 2 }}>
              Customer Support Portal
            </Typography>
          </Typography>
        </DrawerHeader>
        <Divider />
        {/* <List>
          {leftMenus.map((item, index) => (
            <ListItem key={index} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                selected={selectedIndex === item.path}
                onClick={(event) => handleListItemClick(event, item.path)}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.name} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}

        </List> */}
        <List>
          {leftMenus.map((item, index) => (
            item.subItems ? (
              <Box key={index}>
                <ListItem sx={{ display: "block", padding:"4px" }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      
                    }}
                    selected={selectedIndex === item.path}
                    onClick={(event) => handleListItemClick(event, item.path)}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.name} sx={{  fontWeight: "bold" }} />
                  </ListItemButton>
                </ListItem>
                {item.subItems.map((subItem, subIndex) => (
                  <ListItem key={subIndex} disablePadding sx={{ display: "block", pl: 4 }}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                      selected={selectedIndex === subItem.path}
                      onClick={(event) => handleListItemClick(event, subItem.path)}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {subItem.icon}
                      </ListItemIcon>
                      <ListItemText primary={subItem.name} sx={{ opacity: open ? 1 : 0 }} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </Box>
            ) : (
              <ListItem key={index} disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  selected={selectedIndex === item.path}
                  onClick={(event) => handleListItemClick(event, item.path)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.name} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
            )
          ))}
        </List>

        <Divider />
        <List>
          {["Logout"].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                component="a"
                onClick={handleLogout}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}

//export default MiniDrawer
